import { lt } from '@mews/framework';
import { Button, IconName } from '@optimus-web/core';

// TODO: implement onClicks
export const EmptyStateActions = () => (
    <>
        <Button icon={IconName.Upload} onClick={() => {}} size="medium" type="button">
            {lt('ContractsUploadFileLabel')}
        </Button>
        <Button variant="primary" icon={IconName.ManagerReport} onClick={() => {}} size="medium" type="button">
            {lt('ContractGenerateFromTemplateButtonLabel')}
        </Button>
    </>
);
